export default "__VITE_ASSET__eNLtJxa5__"